<template>
  <div class="popup_aler_01" :class="{ open: hasOpen }">
    <div class="outter_box">
      <div class="inner_box">
        <h2 class="title" v-html="title"></h2>
        <button type="button" class="btn_50" @click.prevent="close">{{ buttonText }}</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hasOpen: false,
      title: "",
      buttonText: "",
      fnOk: null
    };
  },
  methods: {
    close() {
      if (this.fnOk !== null && typeof this.fnOk === "function") {
        this.fnOk();
      }
      this.hasOpen = false;
    }
  }
};
</script>
